import { render, staticRenderFns } from "./PiutangNew.vue?vue&type=template&id=a9df9fd6&scoped=true"
import script from "./PiutangNew.vue?vue&type=script&lang=js"
export * from "./PiutangNew.vue?vue&type=script&lang=js"
import style0 from "./PiutangNew.vue?vue&type=style&index=0&id=a9df9fd6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9df9fd6",
  null
  
)

export default component.exports